import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';

import {Localization} from '#core/localization.js';
import {ApplicationConfig} from '#core/config/application-config.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import SCHEMA from './settings-menu.schema.yaml';

class SettingsMenuFeature extends AbstractVisualFeature {
    get name() {
        return 'Settings Menu';
    }

    get configSchema() {
        return SCHEMA;
    }

    getSerializableVisualConfig() {
        return {
            AZMenu: {
                settingsMenu: {
                    hide: !this.config.showInMobileSideMenu,
                },
            },
            MainNavigationBar: {
                showSettingsButton: this.config.showInDesktopHeader,
            },
            SettingsMenu: {
                language: {
                    hide:
                        !this.config.showLanguageSelector ||
                        Localization.availableLanguages.length <= 1 ||
                        ApplicationConfig.isEmbedded,
                },
                oddsFormat: {
                    hide: !this.config.showOddsFormatSelector,
                },
                timeOffset: {
                    hide: !this.config.showTimeOffsetSelector,
                },
                additionalLinks: {
                    links: buildIntentsFromConfig(this.config.additionalLinks),
                },
            },
        };
    }
}

new SettingsMenuFeature(allVisuals);
